<template>
  <div class="xxx">
    <el-form :model="form" ref="form" :rules="rules">
      <div class="formWrapper">
        <div
          :style="{ marginBottom: '10px' }"
          v-for="(itemAG, indexAG) in form.availableGroupNames"
          :key="itemAG.key"
        >
          <el-card v-if="itemAG.myArr.length">
            <el-row>
              <el-col :span="12">
                <el-form-item
                  v-for="(item, index) in itemAG.myArr"
                  :key="item.deviceId"
                  :label="item.deviceShowName"
                >
                  <el-form-item
                    label="分组名称"
                    v-if="form.availableGroupNames.length"
                  >
                    <el-select
                      @change="groupChange"
                      v-model="item.groupId"
                      placeholder=" "
                    >
                      <el-option :key="-1" :label="'无'" :value="undefined" />
                      <el-option
                        v-for="(itemG, indexG) in form.availableGroupNames"
                        :key="indexG"
                        :label="itemG.value"
                        :value="itemG.key"
                      />
                    </el-select>
                  </el-form-item>
                </el-form-item>
              </el-col>
              <!-- 组接口 -->
              <el-col
                :span="6"
                v-for="(itemID, indexID) in itemAG.mySupportInterfaceData"
                :key="indexID"
              >
                <el-form-item
                  @change="tongbuGroupValue"
                  :label="itemID.interfaceShowName"
                  :rules="rules.days"
                  :prop="`availableGroupNames[${indexAG}].mySupportInterfaceData[${indexID}].mySelect`"
                >
                  <el-select v-model="itemID.mySelect" placeholder=" ">
                    <el-option :key="-1" :label="'无'" :value="undefined" />

                    <el-option
                      v-for="(itemI, indexI) in itemID.mySupportInterfaceArr"
                      :key="indexI"
                      :label="itemI.showName"
                      :value="itemI.myId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 组参数 -->
            <template v-if="itemAG.myParameterMetaData.length">
              <AutoForm
                ref="autoForm1"
                :autoForm="itemAG.myParameterMetaData"
              ></AutoForm>
            </template>
          </el-card>
        </div>
        <el-card>
          <template
            v-for="(item, index) in form.deviceSettingItemDtoList"
            :key="item.deviceId"
          >
            <el-form-item v-if="!item.groupId" :label="item.deviceShowName">
              <el-col :span="6" v-if="form.availableGroupNames.length">
                <el-form-item label="分组名称">
                  <el-select
                    @change="groupChange"
                    v-model="item.groupId"
                    placeholder=" "
                  >
                    <el-option :key="-1" :label="'无'" :value="undefined" />
                    <el-option
                      v-for="(itemG, indexG) in form.availableGroupNames"
                      :key="indexG"
                      :label="itemG.value"
                      :value="itemG.key"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="1"></el-col> -->
              <!-- 未分组接口 -->
              <el-col
                :span="11"
                v-for="(itemID, indexID) in item.supportInterfaceData"
                :key="indexID"
              >
                <el-form-item
                  :label="itemID.interfaceShowName"
                  :rules="rules.days"
                  :prop="`deviceSettingItemDtoList[${index}].supportInterfaceData[${indexID}].mySelect`"
                >
                  <el-select v-model="itemID.mySelect" placeholder=" ">
                    <el-option :key="-1" :label="'无'" :value="undefined" />
                    <el-option
                      v-for="(itemI, indexI) in itemID.mySupportInterfaceArr"
                      :key="indexI"
                      :label="itemI.showName"
                      :value="itemI.myId"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
            <!-- 未分组参数 -->
            <template v-if="!item.groupId && item.parameterMetaData.length">
              <AutoForm
                :style="{
                  marginTop: item.supportInterfaceData.length > 0 ? 0 : '-72px',
                }"
                ref="autoForm2"
                :labelWidth="'250px'"
                :autoForm="item.parameterMetaData"
              ></AutoForm>
            </template>
          </template>
          <el-form-item label="&nbsp;">
            <el-button type="primary" @click="add" round>新增</el-button>
            <el-button @click="remove" round>减少</el-button>
          </el-form-item>
        </el-card>
      </div>
      <el-form-item>
        <el-button style="margin-top: 15px" type="primary" @click="submit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Keyboard from "@/components/keyboard/index.vue";
import AutoForm from "@/components/autoForm/index.vue";
import moment from "moment";
import { ElNotification } from "element-plus";

export default {
  name: "Page",
  props: ["deviceId"],
  data() {
    return {
      option: {
        constfan: {
          deviceDefineId: "ConstFan",
          categoryName: "定速风机",
        },
        heat: {
          deviceDefineId: "Heat",
          categoryName: "加热设备",
        },
      },
      form: { availableGroupNames: [], deviceSettingItemDtoList: [] },
      rules: {
        days: [
          {
            required: true,
            message: "必填",
          },
        ],
      },
    };
  },
  components: { Keyboard, AutoForm },
  watch: {
    deviceId() {
      this.init();
    },
  },
  methods: {
    remove() {
      this.form.deviceSettingItemDtoList.pop();
      this.jiagong();
    },
    async add() {
      try {
        let res;
        res = await this.$myRequest({
          url: "/post-one-device-count",
          method: "post",
          data: {
            deviceDefineId: this.deviceId,
            count: 1,
            existsCount: this.form.deviceSettingItemDtoList.length,
          },
        });
        console.log("res add");
        console.log(res);

        this.form.deviceSettingItemDtoList.push(
          res.data.data[0].deviceSettingItemDtoList[0]
        );
        this.jiagong();
      } catch (err) {
        console.log("err add");
        console.log(err);
      }
    },
    groupChange() {
      this.jiagong();
      this.tongbuGroupValue();
    },
    jiagong() {
      for (let k in this.form.availableInterfaces) {
        this.form.availableInterfaces[k].forEach((v, k) => {
          v.myId = v.channelTypeEnum + "-" + v.boardId + "-" + v.channelId;
        });
      }
      this.form.availableGroupNames.forEach((v, k) => {
        v.myArr = [];
        v.mySupportInterfaceData = undefined;
        v.myParameterMetaData = undefined;
      });
      this.form.deviceSettingItemDtoList.forEach((v, k) => {
        v.supportInterfaceData.forEach((vv, kk) => {
          vv.mySupportInterfaceArr =
            this.form.availableInterfaces[vv.supportProtocolTypeEnum];
          if (vv.boardId != undefined && vv.channelId != undefined) {
            vv.mySelect =
              vv.supportProtocolTypeEnum +
              "-" +
              vv.boardId +
              "-" +
              vv.channelId;
          }
        });
        if (v.groupId) {
          this.form.availableGroupNames.forEach((vv, kk) => {
            if (vv.key == v.groupId) {
              vv.myArr.push(v);
              if (!vv.mySupportInterfaceData) {
                //这块要复制
                vv.mySupportInterfaceData = JSON.parse(
                  JSON.stringify(v.supportInterfaceData)
                );
              }
              if (!vv.myParameterMetaData) {
                //这块要复制
                vv.myParameterMetaData = JSON.parse(
                  JSON.stringify(v.parameterMetaData)
                );
              }
            }
          });
        }
        //时间加工
        v.parameterMetaData.forEach((vv, kk) => {
          if (vv.parameterType.parameterEditorType == 1) {
            if (vv.value.rangeBegin && vv.value.rangeEnd) {
              vv.myValue = [
                moment(
                  moment().format("YYYY-MM-DD") + " " + vv.value.rangeBegin
                ).toDate(),
                moment(
                  moment().format("YYYY-MM-DD") + " " + vv.value.rangeEnd
                ).toDate(),
              ];
            } else {
              vv.myValue = [];
            }
          }
        });
      });

      console.log("加工后");
      console.log(this.form);
    },
    fanJiagong(oform) {
      let form = JSON.parse(JSON.stringify(oform));

      for (let k in form.availableInterfaces) {
        form.availableInterfaces[k].forEach((v, k) => {
          delete v.myId;
        });
      }
      form.availableGroupNames.forEach((v, k) => {
        delete v.myArr;
        delete v.mySupportInterfaceData;
        delete v.myParameterMetaData;
      });
      form.deviceSettingItemDtoList.forEach((v, k) => {
        v.supportInterfaceData.forEach((vv, kk) => {
          delete vv.mySupportInterfaceArr;
          delete vv.mySelect;
        });
        //时间加工
        v.parameterMetaData.forEach((vv, kk) => {
          console.log(vv, 'vvvvvvvvvvvvvv');
          if (vv.parameterType.parameterEditorType == 1) {
            if (vv.myValue.length == 2) {
              vv.value = {
                rangeBegin: moment(vv.myValue[0]).format("H:m"),
                rangeEnd: moment(vv.myValue[1]).format("H:m"),
              };
            } else {
              vv.value = {};
            }
            delete vv.myValue;
          }
        });
      });
      return form;
    },
    tongbuGroupValue() {
      //将组的数据同步到设备
      this.form.availableGroupNames.forEach((v, k) => {
        v.myArr.forEach((vv, kk) => {
          vv.supportInterfaceData = JSON.parse(
            JSON.stringify(v.mySupportInterfaceData)
          );
          vv.parameterMetaData = JSON.parse(
            JSON.stringify(v.myParameterMetaData)
          );
        });
      });
      console.log("同步后");
      console.log(this.form);
    },
    async init() {
      // debugger;
      if (!this.deviceId) return;
      try {
        let res;
        res = await this.$myRequest({
          url: "/list-device-setting-by-category",
          method: "get",
          data: { categoryId: this.deviceId },
        });
        console.log("res device init");
        console.log(res);
        this.form = res.data.data;

        this.jiagong();
        this.tongbuGroupValue();
      } catch (err) {
        console.log("err device init");
        console.log(err);
      }
    },
    async submit() {
      try {
        let valRes = await this.$refs.form.validate();
        console.log(valRes);
      } catch (err) {
        console.log("err");
        console.log(err);
        return;
      }
      let bErr = false;
      console.log("form1 form2");
      console.log(this.$refs.autoForm1);
      console.log(this.$refs.autoForm2);
      if (this.$refs.autoForm1) {
        for (let v of this.$refs.autoForm1) {
          try {
            // console.log(v.$refs.form.validate);
            let valRes = await v.$refs.form.validate();
            console.log(valRes);
          } catch (err) {
            console.log("err autoForm1");
            console.log(err);
            bErr = true;
            // return;
          }
        }
      }
      if (this.$refs.autoForm2) {
        for (let v of this.$refs.autoForm2) {
          try {
            // console.log(v.$refs.form.validate);
            let valRes = await v.$refs.form.validate();
            console.log(valRes);
          } catch (err) {
            console.log("err autoForm2");
            console.log(err);
            bErr = true;
            // return;
          }
        }
      }

      if (bErr) {
        return;
      }
      // console.log(this.form);
      // return;
      try {
        // console.log(this.form.deviceSettingItemDtoList);
        this.form.deviceSettingItemDtoList.forEach((v, k) => {
          v.supportInterfaceData.forEach((vv, kk) => {
            let arr = vv.mySelect.split("-");
            vv.boardId = arr[1];
            vv.channelId = arr[2];
          });
        });

        console.log("submit form");
        //奇怪，分组的子组件没有同步，未分组的没问题，之前就有问题
        this.tongbuGroupValue();
        // console.log(JSON.stringify(this.fanJiagong(this.form)));
        console.log(this.fanJiagong(this.form));
        // return;
        let res = await this.$myRequest({
          url: "/post-device-setting",
          method: "post",
          data: this.fanJiagong(this.form),
        });
        ElNotification({
          title: "提示",
          message: "操作成功",
          type: "success",
        });
        this.init();
      } catch (err) {
        console.log("save err");
        console.log(err);
      }
    },
  },
  mounted() {
    // console.log(this.$route.path.split("/")[3]);
    console.log("device form mounted");
    // this.init();
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
